export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/freehand_digital.3fccc63.png";